import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../../services/auth';
import axios from 'axios';
import './AddressSelection.css';
import Navbar from '../Navbar';
import Navbar2 from '../Navbar2';
import Footer from '../Footer/Footer';

function AddressSelection() {
    const [addresses, setAddresses] = useState([]);
    const [selectedAddressId, setSelectedAddressId] = useState(null);
    const [showNewAddressForm, setShowNewAddressForm] = useState(false);
    const [editingAddress, setEditingAddress] = useState(null);
    const [addressForm, setAddressForm] = useState({
        name: '',
        phone: '',
        pincode: '',
        address: '',
        city: '',
        state: '',
        isDefault: false
    });
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState(null);

    const navigate = useNavigate();
    

    useEffect(() => {
        const currentUser  = getCurrentUser();
        if (!currentUser) {
            navigate('/login');
            return;
        }
        setUser(currentUser);
        fetchAddresses();
    }, [navigate]);

    const fetchAddresses = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`http://localhost:3001/addresses`, {
                withCredentials: true,
                headers: {
                    'Authorization': `Bearer ${getCurrentUser()?.token}`
                }
            });
            setAddresses(response.data);
            
            // Auto-select default address if exists
            const defaultAddress = response.data.find(addr => addr.isDefault);
            if(defaultAddress) {
                setSelectedAddressId(defaultAddress._id);
            }
        } catch (error) {
            console.error("Error fetching addresses:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleNewAddressChange = (e) => {
        setAddressForm({
            ...addressForm,
            [e.target.name]: e.target.value
        });
    };

    const handleSaveNewAddress = async (e) => {
        e.preventDefault();
        try {
            if (editingAddress) {
                await axios.put(`http://localhost:3001/addresses/${editingAddress._id}`, {
                    ...addressForm,
                    userEmail: user.email
                }, { withCredentials: true });
            } else {
                await axios.post('http://localhost:3001/addresses', {
                    ...addressForm,
                    userEmail: user.email
                }, { withCredentials: true });
            }
            await fetchAddresses();
            resetAddressForm();
        } catch (error) {
            console.error("Error saving address:", error);
        }
    };


    const handleEditAddress = (address) => {
        setEditingAddress(address);
        setAddressForm({
            name: address.name,
            phone: address.phone,
            pincode: address.pincode,
            address: address.address,
            city: address.city,
            state: address.state,
            isDefault: address.isDefault
        });
        setShowNewAddressForm(true);
    };

    const handleDeleteAddress = async (addressId) => {
        if(window.confirm('Are you sure you want to delete this address?')) {
            try {
                await axios.delete(`http://localhost:3001/addresses/${addressId}`,{
                    withCredentials: true
                });
                await fetchAddresses();
                if(selectedAddressId === addressId){
                    setSelectedAddressId(null);
                }
            } catch (error) {
                console.error("Error deleting address:", error);
            }
        }
    }

    const resetAddressForm = () => {
        setEditingAddress(null);
        setShowNewAddressForm(false);
        setAddressForm({
            name: '',
            phone: '',
            pincode: '',
            address: '',
            city: '',
            state: '',
            isDefault: false
        });
    }

    const proceedToPayment = () => {
        if(!selectedAddressId) {
            alert('Please select an address');
            return;
        }
        const selectedAddress = addresses.find(addr => addr._id === selectedAddressId);
        navigate('/payment', { state: { address: selectedAddress } });
    };

    return (
        <>
            <Navbar/>
            <div className="sticky-navbar">
                <Navbar2/>
            </div>
            <div className="address-selection-container">
            <h2>Select Delivery Address</h2>

            {isLoading ? (
                <div className="loading-spinner">Loading addresses...</div>
            ) : (
                <>
                    <div className="address-list">
                        {addresses.length > 0 ? (
                            addresses.map(address => (
                                <div 
                                    key={address._id}
                                    className={`address-card ${selectedAddressId === address._id ? 'selected' : ''}`}
                                    onClick={() => setSelectedAddressId(address._id)}
                                >
                                    <div className="address-radio">
                                        <input
                                            type="radio"
                                            name="selectedAddress"
                                            checked={selectedAddressId === address._id}
                                            onChange={() => setSelectedAddressId(address._id)}
                                        />
                                    </div>
                                    <div className="address-details">
                                        <h5>
                                            {address.name}
                                            {address.isDefault && <span className="default-badge">Default</span>}
                                        </h5>
                                        <p>{address.address}</p>
                                        <p>{address.city}, {address.state} - {address.pincode}</p>
                                        <p>Phone: {address.phone}</p>
                                    </div>
                                    <div className="address-actions">
                                        <button 
                                        className="btn-edit"
                                        onClick={() => handleEditAddress(address)}
                                        >Edit</button>
                                        <button 
                                        className="btn-delete"
                                        onClick={() => handleDeleteAddress(address._id)}
                                        >Delete</button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="no-addresses">
                                <p>You don't have any saved addresses yet.</p>
                            </div>
                        )}
                    </div>

                    <div className="action-buttons">
                        <button 
                            className="btn-add-address"
                            onClick={() => {
                                setEditingAddress(null);
                                setShowNewAddressForm(true);
                            }}
                        >
                            + Add New Address
                        </button>
                        {addresses.length > 0 && (
                            <button 
                                className="btn-proceed"
                                onClick={proceedToPayment}
                                disabled={!selectedAddressId}
                            >
                                Proceed to Payment
                            </button>
                        )}
                    </div>

                    {showNewAddressForm && (
                        <div className="new-address-form">
                            <h3>{editingAddress ? 'Edit Address' : 'Add New Address'}</h3>
                            <form onSubmit={handleSaveNewAddress}>
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Full Name</label>
                                        <input 
                                            type="text" 
                                            name="name"
                                            value={addressForm.name}
                                            onChange={handleNewAddressChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Phone Number</label>
                                        <input 
                                            type="tel" 
                                            name="phone"
                                            value={addressForm.phone}
                                            onChange={handleNewAddressChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Complete Address</label>
                                    <textarea
                                        name="address"
                                        value={addressForm.address}
                                        onChange={handleNewAddressChange}
                                        required
                                    />
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Pincode</label>
                                        <input 
                                            type="text" 
                                            name="pincode"
                                            value={addressForm.pincode}
                                            onChange={handleNewAddressChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>City</label>
                                        <input 
                                            type="text" 
                                            name="city"
                                            value={addressForm.city}
                                            onChange={handleNewAddressChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>State</label>
                                        <input 
                                            type="text" 
                                            name="state"
                                            value={addressForm.state}
                                            onChange={handleNewAddressChange}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="form-checkbox">
                                    <input 
                                        type="checkbox" 
                                        id="isDefault"
                                        checked={addressForm.isDefault}
                                        onChange={(e) => setAddressForm({
                                            ...addressForm,
                                            isDefault: e.target.checked
                                        })}
                                    />
                                    <label htmlFor="isDefault">Set as default address</label>
                                </div>

                                <div className="form-actions">
                                    <button 
                                        type="button"
                                        className="btn-cancel"
                                        onClick={resetAddressForm}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn-save">
                                        Save Address
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                </>
            )}
            </div>

            <Footer/>
        </>
        
    );
}

export default AddressSelection;